// DialogEstimateAdd Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import app from '../../../app.jsx'
import Dialog from '../../../common/layout/dialog/dialog.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import FormAutoComplete from '../../../common/form/auto_complete/auto_complete.jsx'
import Select from '../../../common/form/select/select.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import FabButtonManager from '../../../lib/fabbuttonmanager.jsx'
import { Spinner } from '../../../common/common/spinner.jsx'

class DialogEstimateAdd extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: false,
      contactId: '',
      contactName: '',
      displayContactName: '',
      projectId: '',
      showError: false,
      dataDate: null,
      loading: {
        isSubmitting: false
      }
    }

    this.data = {
      projects: [],
      contacts: [],
      bHideDrop: false
    }

    this._bContactSearchPending = false
    this._contactSearchKeyword = ''
    this._references = {
      inputContact: React.createRef(),
      selectProject: React.createRef()
    }
  }

  static get propTypes () {
    return {
      onSubmit: PropTypes.func,
      contactSearch: PropTypes.func,
      getProjects: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      onSubmit: null,
      contactSearch: null,
      getProjects: null
    }
  }

  show () {
    FabButtonManager.setVisible(false)
    this.setState({ active: true })
  }

  hide () {
    FabButtonManager.setVisible(true)
    this.setState({
      active: false,
      contactId: '',
      contactName: '',
      displayContactName: '',
      projectId: '',
      showError: false
    })

    this.data.bHideDrop = false
  }

  isActive () {
    return this.state.active
  }

  toggleLoading (key, isLoading) {
    this.setState(prevState => ({ ...prevState, loading: { ...prevState.loading, [key]: isLoading } }))
  }

  componentDidMount () {
    document.body.addEventListener('keydown', this._onKeyDown)
  }

  componentWillUnmount () {
    document.body.removeEventListener('keydown', this._onKeyDown)
  }

  _onKeyDown = (ev) => {
    if (this.state.active && ev.keyCode === 13) {
      this._onFormSubmit(ev)
    }
  };

  render () {
    const { loading: { isSubmitting } } = this.state
    const classHeader = !this.state.showError
      ? 'dialogform-header'
      : 'dialogform-header showerr'

    return (
      <Dialog active={this.state.active} onClose={this.hide.bind(this)}>
        <div className='dialog-form estimateadd-form'>
          <div className={classHeader}>
            {!this.state.showError ? (
              <div className='title'>
                <IntlMessage ident='estimate.form.addEstimateTitle' />
              </div>
            ) : (
              <div className='info'>
                <IntlMessage ident='estimate.form.addEstimateErrorInfo' />
              </div>
            )}
            <IconButton
              icon='wizard-close'
              className='modal wizard-close dialog-form-close'
              canHover={false}
              onClick={this._onClickClose.bind(this)}
            />
          </div>
          <div className='dialogform-content'>
            <form
              className='form'
              method='post'
              noValidate
              action='#'
              onSubmit={this._onFormSubmit.bind(this)}
            >
              <div className='form-layout'>
                <div className='layoutcol'>
                  <div className='formsection'>
                    <div className='formrow'>
                      <div className='formcol'>
                        <FormAutoComplete
                          label='estimate.form.labelClient'
                          name='contactId'
                          ref={this._references.inputContact}
                          validations={['required']}
                          value={this.state.displayContactName}
                          displayValue={this.state.displayContactName}
                          options={this.data.contacts}
                          onChange={this._handleSearchContact.bind(this)}
                          onSelect={this._handleContactSelect.bind(
                            this,
                            'contactId'
                          )}
                          addLabel='project.form.addNewClient'
                          addValue={this.state.contactName}
                          addName='contactName'
                          hideAdd
                          hasAutoSelect
                          onAdd={this._onChangeInput.bind(this, 'contactName')}
                        />
                      </div>
                    </div>
                    {this.data.bHideDrop ? (
                      <div className='formrow'>
                        <div className='formcol'>
                          <span className='norecrds'>
                            <IntlMessage ident='estimate.form.noRecordsError' />
                          </span>
                        </div>
                      </div>
                    ) : (
                      <div className='formrow'>
                        <div className='formcol'>
                          <Select
                            options={this.data.projects}
                            name='projectId'
                            label='estimate.form.labelProject'
                            ref={this._references.selectProject}
                            className='form-dropdown'
                            onChange={this._onChangeInput.bind(
                              this,
                              'projectId'
                            )}
                            value={this.state.projectId}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </form>
            <IconButton
              type='primary'
              size='big'
              icon={!isSubmitting ? 'common-success-tick' : undefined}
              title='estimate.form.createEstimateTitle'
              canHover={false}
              onClick={this._onFormSubmit.bind(this)}
            >
              {isSubmitting ? <Spinner size={28} color='#fff' /> : null}
            </IconButton>
          </div>
        </div>
      </Dialog>
    )
  }

  /* Event Handlers */
  _onFormSubmit (ev) {
    ev.preventDefault()

    this.toggleLoading('isSubmitting', true)
    let noErrors = 0
    if (
      (this._references.inputContact.current &&
        !this._references.inputContact.current.validate()) ||
      !this.state.contactId
    ) {
      noErrors++
    }
    if (
      this._references.selectProject.current &&
      !this._references.selectProject.current.validate()
    ) {
      noErrors++
    }
    if (!this.state.projectId) {
      noErrors++
    }

    if (noErrors === 0) {
      const data = {
        createdById: app.loggedInId,
        projectId: this.state.projectId,
        contactId: this.state.contactId,
        status: 'Draft',
        budget: {
          phases: [
            {
              title: '',
              fromDate: null,
              toDate: null,
              status: 'estimate',
              total: 0,
              percentage: 0,
              spentAmount: 0
            }
          ],
          totalSpent: 0,
          total: 0
        }
      }

      this.props.onSubmit(data, () => {
        this.toggleLoading('isSubmitting', true)
      })
    } else {
      this.setState({ showError: true, loading: { isSubmitting: false } })
    }
  }

  _onClickClose (ev) {
    ev.preventDefault()
    this.hide()
  }

  _onChangeInput (name, value) {
    if (
      name === 'projectId' &&
      value &&
      this._references.selectProject.current
    ) {
      this._references.selectProject.current.clearError()
    }
    this.setState({ [name]: value })
  }

  _handleSearchContact (keyword) {
    if (keyword && this._references.inputContact.current) {
      this._references.inputContact.current.clearError()
    }

    this.setState({ displayContactName: keyword })
    this._processContactSearch(keyword)
  }

  _processContactSearch (keyword) {
    if (keyword.length < 1) return

    if (!this._bContactSearchPending) {
      this._bContactSearchPending = true
      if (this.props.contactSearch) {
        this.props.contactSearch(
          keyword,
          this._onSearchRecieved.bind(this, keyword)
        )
      }
    } else {
      this._contactSearchKeyword = keyword
    }
  }

  _onSearchRecieved (keyword, result) {
    this._bContactSearchPending = false

    this.data.contacts = result.filter(contact => contact.bArchived === false)
    const stateObj = {}
    if (result && result.length > 0) {
      stateObj.contactId = ''
      stateObj.contactName = keyword
    }

    this.setState(stateObj)

    if (this._contactSearchKeyword) {
      const keyword = this._contactSearchKeyword
      this._contactSearchKeyword = ''
      this._processContactSearch(keyword)
    }
  }

  _handleContactSelect (name, obj) {
    if (obj) {
      this.setState({ [name]: obj.value, displayContactName: obj.label })

      this.props.getProjects(obj.value, (projectRes) => {
        this.data.projects = projectRes

        this.data.bHideDrop = false
        if (this.data.projects.length === 0) {
          this.data.bHideDrop = true
        }

        this.setState({ dataDate: new Date() })
      })
    } else {
      this.data.projects = []
      this.data.bHideDrop = false

      this.setState({ [name]: '' })
    }
  }
}

export default DialogEstimateAdd
